"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _EoaWallet_client, _EoaWallet_config;
Object.defineProperty(exports, "__esModule", { value: true });
exports.EoaWallet = void 0;
const viem_1 = require("viem");
const actions_1 = require("viem/actions");
const Error_1 = require("../Error");
const OperationStatus_1 = require("../enum/OperationStatus");
const chain_1 = require("../utils/chain");
const error_1 = require("../utils/error");
const Helpers_1 = require("./Helpers");
const Wallet_1 = require("./Wallet");
class EoaWallet extends Wallet_1.Wallet {
    constructor(config, client) {
        super(client.chain);
        _EoaWallet_client.set(this, void 0);
        _EoaWallet_config.set(this, void 0);
        this.getFeeData = async () => {
            const result = await this.publicClient.estimateFeesPerGas();
            return {
                maxFeePerGas: result.maxFeePerGas,
                maxPriorityFeePerGas: result.maxPriorityFeePerGas,
            };
        };
        __classPrivateFieldSet(this, _EoaWallet_client, client, "f");
        __classPrivateFieldSet(this, _EoaWallet_config, config, "f");
    }
    get client() {
        return __classPrivateFieldGet(this, _EoaWallet_client, "f");
    }
    get rpcUrl() {
        return __classPrivateFieldGet(this, _EoaWallet_config, "f").eoa.rpcUrl;
    }
    get address() {
        return __classPrivateFieldGet(this, _EoaWallet_client, "f").account.address;
    }
    async getNonce() {
        const nonce = await (0, actions_1.getTransactionCount)(__classPrivateFieldGet(this, _EoaWallet_client, "f"), {
            address: this.address,
        });
        return BigInt(nonce);
    }
    signTransaction(tx) {
        return __classPrivateFieldGet(this, _EoaWallet_client, "f").account.signTransaction(tx);
    }
    signMessage(message) {
        return __classPrivateFieldGet(this, _EoaWallet_client, "f").account.signMessage({
            message: message,
        });
    }
    get publicClient() {
        return this.client.extend(viem_1.publicActions);
    }
    estimateGas(tx) {
        return (0, actions_1.estimateGas)(__classPrivateFieldGet(this, _EoaWallet_client, "f"), tx);
    }
    async deployContract(deploy, options) {
        try {
            options?.onStatusChange?.(OperationStatus_1.OperationStatus.PreparingTransaction);
            const prepared = await __classPrivateFieldGet(this, _EoaWallet_client, "f").prepareTransactionRequest({
                to: null,
                data: (0, error_1.assertHex)(deploy.bytecode, 'bytecode'),
                value: deploy.value ?? BigInt(0),
            });
            options?.onStatusChange?.(OperationStatus_1.OperationStatus.SendingTransaction);
            const hash = await this.sendTransaction(prepared);
            options?.onStatusChange?.(OperationStatus_1.OperationStatus.GettingContractAddress);
            const address = (0, viem_1.getContractAddress)({
                from: this.address,
                nonce: BigInt(prepared.nonce),
            });
            return {
                hash,
                address,
            };
        }
        catch (e) {
            throw (0, error_1.parseError)(e);
        }
    }
    signTypedData(typedData) {
        return __classPrivateFieldGet(this, _EoaWallet_client, "f").account.signTypedData({
            domain: typedData.domain,
            types: typedData.types,
            message: typedData.message,
            primaryType: typedData.primaryType,
        });
    }
    async sendTransaction(tx, options) {
        try {
            options?.onStatusChange?.(OperationStatus_1.OperationStatus.PreparingTransaction);
            const prepared = await __classPrivateFieldGet(this, _EoaWallet_client, "f").prepareTransactionRequest(tx);
            options?.onStatusChange?.(OperationStatus_1.OperationStatus.SendingTransaction);
            return __classPrivateFieldGet(this, _EoaWallet_client, "f").sendTransaction(prepared);
        }
        catch (e) {
            throw (0, error_1.parseError)(e);
        }
    }
    export() {
        return {
            version: '1.0',
            eoa: (0, Helpers_1.exportSource)(__classPrivateFieldGet(this, _EoaWallet_config, "f").eoa),
        };
    }
    static async create(config) {
        if (!(0, Helpers_1.isValidSource)(config.eoa)) {
            throw new Error_1.KriptonioError({
                message: 'privateKey or mnemonic must be provided',
            });
        }
        const publicClient = (0, viem_1.createPublicClient)({
            transport: (0, viem_1.http)(config.eoa.rpcUrl, {
                batch: {
                    batchSize: 1000,
                    wait: 5,
                },
            }),
        });
        const chainId = await publicClient.getChainId();
        const chain = (0, chain_1.getChain)(chainId);
        const client = this.createEoaClient(config, chain);
        return new EoaWallet(config, client);
    }
    static createEoaClient(config, chain) {
        return (0, viem_1.createWalletClient)({
            chain,
            account: (0, Helpers_1.sourceToAccount)(config.eoa),
            transport: (0, viem_1.http)(config.eoa.rpcUrl, { batch: true }),
        });
    }
    static async computeAddress(config, rpcUrl) {
        const wallet = await EoaWallet.create({
            eoa: {
                ...(0, Helpers_1.exportSource)(config.eoa),
                rpcUrl,
            },
        });
        return wallet.address;
    }
}
exports.EoaWallet = EoaWallet;
_EoaWallet_client = new WeakMap(), _EoaWallet_config = new WeakMap();
